import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-mobile-links',
    templateUrl: './mobile-links.component.html',
    styleUrls: ['./mobile-links.component.scss']
})
export class MobileLinksComponent {
    @Input() links = [];
    @Input() level = 0;

    @Output() itemClick: EventEmitter<any> = new EventEmitter();

    constructor() { }

    onItemClick(item): void {
        this.itemClick.emit(item);
    }
}
